var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"AppUserManagementEditUserTab"}},[_c('div',{staticStyle:{"height":"10px"}}),_vm._v(" "),_c('editUserContents',{ref:"editContents",attrs:{"selectedid":_vm.selectedid,"is-edit":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bfbe6e3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppUserManagementEditUserTab.vue
// module id = null
// module chunks = 